const flattenObject = (object) => {
	if(typeof(object) !== 'object' || object === null) return `${object}`;
	const flat = {};
	Object.keys(object).forEach((key) => {
		if(object[key] === null){
			flat[key] = 'null';
		} if (typeof object[key] === 'object') {
			const flatChild = flattenObject(object[key]);
			Object.keys(flatChild).forEach((childKey) => {
				flat[`${key}.${childKey}`] = flatChild[childKey];
			});
		} else {
			flat[key] = object[key];
		}
	});
	return flat;
};
export default flattenObject;
